export const APTOS_MAINNET_API_KEY =
  'AG-7YT2HCHURJBJUEGGTCLSQ2G77O1WNCVI3';

export const getAptosAuthHeaders = (
  apiKey?: string,
  headers: Record<string, string> = {},
): Record<string, string> => {
  const authHeaders: Record<string, string> = apiKey
    ? { Authorization: `Bearer ${apiKey}` }
    : {};

  return {
    ...authHeaders,
    ...headers,
  };
};
